var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.74046 1.00007C14.8305 0.860072 19.0005 4.95007 19.0005 10.0001H20.7905C21.2405 10.0001 21.4605 10.5401 21.1405 10.8501L18.3505 13.6401C18.1505 13.8401 17.8405 13.8401 17.6405 13.6401L14.8505 10.8501C14.5405 10.5401 14.7605 10.0001 15.2105 10.0001H17.0005C17.0005 6.10007 13.8205 2.95007 9.90046 3.00007C6.18046 3.05007 3.05046 6.18007 3.00046 9.90007C2.95046 13.8101 6.10046 17.0001 10.0005 17.0001C11.2505 17.0001 12.4205 16.6601 13.4405 16.0901C13.8305 15.8701 14.3105 15.9501 14.6205 16.2701C15.0805 16.7301 14.9905 17.5201 14.4205 17.8401C13.1105 18.5701 11.6105 19.0001 10.0005 19.0001C4.95046 19.0001 0.860458 14.8301 1.00046 9.74007C1.13046 5.05007 5.05046 1.13007 9.74046 1.00007Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refreshIcon.300d3f54.svg";
export { ForwardRef as ReactComponent };